import { Icon } from 'antd';
import styled from 'styled-components';

export const RightPanelWrapper = styled.div`
  display: initial;
  width: 100%;
  
  .ant-collapse .ant-collapse-item .ant-collapse-header .ant-collapse-arrow {
    left: initial;
    right: 15px;
  }
  
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 10px 5px 10px 15px;
  }
`;

export const RequestMessage = styled.div`
  color: ${({ theme }) => theme.colors.mainDark};
  white-space: pre-wrap;
  word-break: break-word;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondaryDark};
  font-weight: 400;
  font-size: 14px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  margin-right: 5px;
  pointer-events: none;
`;

export const ArrowWrap = styled(Icon)`
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/right-panel/styled-components.js